import { store } from "@redux"

const isNewComboInPreviousOrder = (orderCombo) => {
  const {
    orderForEditDetails
  } = store.getState()

  const previousOrder =
    orderForEditDetails

  if (previousOrder === null) return false

  const isNew =
    !previousOrder.combos.some(previousOrderCombo =>
      previousOrderCombo.code === orderCombo.code
        ?
        previousOrderCombo.items.some(previousOrderComboItem =>
          orderCombo.items.some(orderComboItem =>
            previousOrderComboItem.comboSetItemId === orderComboItem.comboSetItemId &&
            previousOrderComboItem.optionId === orderComboItem.optionId
          )
        )
        : false
    )

  return isNew
}

export default isNewComboInPreviousOrder